module.exports = __webpack_public_path__ + "assets/item-tag8369d2a8.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/more/item-tag.png
// module id = 958
// module chunks = 23